import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { LogoMark } from "./Logo";
import { SITE } from "@/constants/site";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Destinations", href: "#destinations" },
  { label: "Advisory", href: "#advisory" },
  { label: "Process", href: "#process" },
  { label: "Stories", href: "#testimonials" },
];

const goEnquiry = () => document.getElementById("enquiry")?.scrollIntoView();

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="navbar" className="fixed top-0 inset-x-0 z-50 bg-[#F8FAFC]/85 backdrop-blur-md border-b border-slate-900/10">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
        <a href="#home" data-testid="nav-logo" className="flex items-center gap-2.5">
          <LogoMark className="w-9 h-9" />
          <span className="leading-tight">
            <span className="block font-heading font-bold text-lg text-[#0B192C]">Orion Edcon</span>
            <span className="block text-[10px] tracking-[0.22em] uppercase text-amber-700 font-semibold">Services</span>
          </span>
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.href} data-testid={`nav-link-${l.label.toLowerCase()}`} href={l.href}
              className="group relative text-sm font-medium text-slate-600 hover:text-[#0B192C] transition-colors">
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-amber-600 transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-4">
          <a href={SITE.phoneHref} data-testid="nav-phone-link" className="flex items-center gap-1.5 text-sm font-semibold text-[#0B192C]">
            <Phone className="w-4 h-4 text-amber-600" /> {SITE.phone}
          </a>
          <button data-testid="nav-counselling-btn" onClick={goEnquiry}
            className="rounded-full bg-[#0B192C] text-white text-sm font-semibold px-5 py-2.5 hover:bg-amber-600 transition-colors duration-300">
            Book Counselling
          </button>
        </div>
        <button data-testid="nav-menu-toggle" className="lg:hidden text-[#0B192C]" onClick={() => setOpen(!open)}>
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-[#F8FAFC] border-t border-slate-200 px-5 py-4 space-y-3" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}
              className="block text-sm font-medium text-slate-700 py-1">{l.label}</a>
          ))}
          <button data-testid="nav-counselling-btn-mobile" onClick={() => { setOpen(false); goEnquiry(); }}
            className="w-full rounded-full bg-[#0B192C] text-white text-sm font-semibold px-5 py-2.5">
            Book Counselling
          </button>
        </div>
      )}
    </header>
  );
};
